import { render } from "./NotAllowed.vue?vue&type=template&id=1a8e6eb8"
import script from "./NotAllowed.vue?vue&type=script&lang=js"
export * from "./NotAllowed.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/scm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__